import { useFeatureFlag } from 'v2/core/clients/featureFlag';
import { FeatureFlagType } from 'v2/core/clients/featureFlag/flags';

const featureFlag: FeatureFlagType = {
  name: 'set-as-default-home',
  fallback: false,
};

export const useIsSetAsDefaultHomeEnabled = () => {
  const [, isEnabled] = useFeatureFlag(featureFlag);

  return isEnabled;
};
